import React from 'react'

function Test() {
  return (
   <div>{window.location.href}</div>
  )
}

export default Test